var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "star-rating" },
    [
      _vm._l(_vm.fullStars, function (n) {
        return _c("icon", {
          key: "full-" + n,
          staticClass: "star-rating__star",
          attrs: { name: "star", width: "14px", height: "14px" },
        })
      }),
      _vm._l(_vm.halfStars, function (n) {
        return _c("icon", {
          key: "half-" + n,
          staticClass: "star-rating__star star-rating__star--half",
          attrs: { name: "star-half", height: "14px", width: "14px" },
        })
      }),
      _vm._l(_vm.emptyStars, function (n) {
        return _c("icon", {
          key: "empty-" + n,
          staticClass: "star-rating__star star-rating__star--empty",
          attrs: { name: "star-empty", height: "14px", width: "14px" },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }